import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDatepickerConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';
import { amkaValidator } from '../../core/validators/amka.validator';
import { surgeryStatuses } from '../../shared/components/surgery-status-dropdown/surgery-status-dropdown.config';
import { SurgeryIdikaService } from '../../../services/surgery-idika/surgery-idika.service';

const currentDate = new Date();
const dateNow = createDateNowUtc();
export const startFrom2020 = new Date(Date.UTC(2020, 0, 1)); // January 1, 2020

export const idikaSurgerySearchForm = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'hospitalID',
      label: 'Νοσοκομείο',
      styleClass: 'col-6',
      control: new FormControl(null),
    }),
    new EoCustomControlConfig({
      name: 'clinicID',
      label: 'Κλινική',
      styleClass: 'col-6',
      control: new FormControl(null),
    }),
    new EoDatepickerConfig({
      name: 'dateFrom',
      styleClass: 'col-6',
      label: 'Ημ. εισαγωγής στην ΕΛΧ από',
      showClear: false,
      appendTo: 'body',
      control: new FormControl(startFrom2020),
      showButtonBar: true,
      placeholder: 'Παρακαλώ επιλέξτε ημερομηνία',
    }),
    new EoDatepickerConfig({
      name: 'dateTo',
      styleClass: 'col-6',
      label: 'Ημ. εισαγωγής στην ΕΛΧ έως',
      showClear: false,
      appendTo: 'body',
      control: new FormControl(dateNow),
      showButtonBar: true,
      placeholder: 'Παρακαλώ επιλέξτε ημερομηνία',
    }),
    new EoCustomControlConfig({
      name: 'patientAmka',
      styleClass: 'col-6',
      type: 'text',
      label: 'ΑΜΚΑ Ασθενούς',
      control: new FormControl(null)
    }),
    new EoDropdownConfig({
      name: 'status',
      label: 'Κατάσταση',
      placeholder: 'Επιλέξτε κατάσταση',
      styleClass: 'col-6',
      options: surgeryStatuses,
      optionLabel: 'label',
      optionValue: 'value',
      appendTo: 'body',
      control: new FormControl(null),
      showClear: true
    }),
  ],
});

export const idikaSurgerySearchFormConfig: EoFormPanelConfig[] = [
  idikaSurgerySearchForm,
];

const setFc = (formGroupName: string, formControlName: string, value: any) => {
  idikaSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.setValue(value);
};

const disableFc = (formGroupName: string, formControlName: string) => {
  idikaSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.disable();
};

const enableFc = (formGroupName: string, formControlName: string) => {
  idikaSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.enable();
};

export const initSurgerySearchForm = (): void => {
  initDatePickers();
};



export const getDateRange = (): {
  dateFrom: Date | null;
  dateTo: Date | null;
} => {
  const dateFromControl = idikaSurgerySearchForm.config.find(
    (c) => c.name === 'dateFrom'
  )?.control as FormControl;
  const dateToControl = idikaSurgerySearchForm.config.find(
    (c) => c.name === 'dateTo'
  )?.control as FormControl;

  return {
    dateFrom: dateFromControl?.value || null,
    dateTo: dateToControl?.value || null,
  };
};

function createDateNowUtc() {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    )
  );
}

const initDatePickers = (): void => {
  setFc('form', 'dateFrom', startFrom2020);
  setFc('form', 'dateTo', dateNow);
};

export function clearClinicDropdown() {
  setFc('form', 'clinicID', null);
}

export function setSearchParams(savedSearchParams: any) {
    setFc('form', 'hospitalID', savedSearchParams.hospitalID);
    setFc('form', 'clinicID', savedSearchParams.clinicID);
    setFc('form', 'dateFrom', savedSearchParams.dateFrom);
    setFc('form', 'dateTo', savedSearchParams.dateTo);
    setFc('form', 'patientAmka', savedSearchParams.patientAmka);
    setFc('form', 'status', savedSearchParams.status);
}


export const addRequiredValidator = (formGroupName: string, formControlName: string): void => {
  const control = idikaSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control;

  if (control) {
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
};

export const clearValidators = (formGroupName: string, formControlName: string): void => {
  const control = idikaSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control;

  if (control) {
    control.clearValidators();
    control.updateValueAndValidity();
  }
};
